"use client";

import { Check } from "lucide-react";

export interface VehicleAmenitiesProps {
  amenities: string[];
}

export function VehicleAmenities({ amenities }: VehicleAmenitiesProps) {
  return (
    <div className="mb-8 border-y border-gray-200 py-8">
      <h2 className="text-2xl font-semibold mb-4">Amenities</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {amenities.map((amenity, index) => (
          <div key={index} className="flex items-center gap-2 p-2">
            <Check className="h-5 w-5 text-green-500" />
            <span className="text-sm text-[#020817]">{amenity}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
